import { type Mesh } from '@/gfx/mesh';
import { createBoxMesh } from './box';

// A boulder is a unit box that callers scale non-uniformly (with a Y
// rotation) per instance so a small handful look like distinct rocks.
export const createBoulderMesh = (): Mesh => createBoxMesh(1, 1, 1);
